import { Option } from "./types";

export function findOptionByValue(options: Option[], value: string): Option[] | null {
  const option = options.find(option => option.value === value) || null;

  return option ? [option] : null;
}
